import { matchesWords, type ResultOf } from '@horof/shared';
import { graphql } from '../gql';

export const CommitteeMetersDocument = graphql(`
  query CommitteeMeters {
    meters(orderBy: [SORT_ORDER_ASC, METER_NO_ASC]) {
      nodes {
        id
        label
        meterNo
        meterAddress
        meterStatus
        sortOrder
        member {
          id
          fullName
        }
      }
    }
  }
`);

export const MeterDetailsDocument = graphql(`
  query MeterDetails($id: UUID!) {
    meter(id: $id) {
      id
      label
      meterNo
      meterAddress
      meterStatus
      statusReason
      statusChangedAt
      photo {
        id
        url
        createdAt
        uploadedBy
      }
      sortOrder
      connectedAt
      memberId
      member {
        id
        fullName
        meters(filter: { meterStatus: { equalTo: CONNECTED } }) {
          nodes {
            id
            label
          }
        }
      }
      meterStatusChanges(orderBy: [CHANGED_AT_DESC], first: 10) {
        nodes {
          id
          fromStatus
          toStatus
          reason
          changedOn
          changedBy
          reading
          meterByReplacedBy {
            label
          }
        }
      }
      recentBills: bills(orderBy: [BILL_MONTH_DESC], first: 6) {
        nodes {
          id
          billMonth
          currentReading
          consumption
          billTotal
          billStatus
          readingPhoto {
            id
          }
        }
      }
    }
  }
`);

export const MemberChoicesDocument = graphql(`
  query MemberChoices {
    members(orderBy: [LAST_NAME_ASC, FIRST_NAME_ASC]) {
      nodes {
        id
        fullName
        memberAddress
      }
    }
  }
`);

export const UpdateMeterDocument = graphql(`
  mutation UpdateMeter($id: UUID!, $patch: MeterPatch!) {
    updateMeter(input: { id: $id, patch: $patch }) {
      meter {
        id
        label
        meterNo
        meterAddress
        meterStatus
        sortOrder
        memberId
      }
    }
  }
`);

export const CreateMeterDocument = graphql(`
  mutation CreateMeter($meter: MeterInput!) {
    createMeter(input: { meter: $meter }) {
      meter {
        id
      }
    }
  }
`);

type MeterNode = NonNullable<
  NonNullable<
    ResultOf<typeof CommitteeMetersDocument>['meters']
  >['nodes'][number]
>;

export const matchesMeter = (m: MeterNode, query: string) =>
  matchesWords([m.label, m.meterNo, m.meterAddress, m.member?.fullName], query);
